import { initialPagination } from '@app/constants/pagination';
import { ITableData } from './SessionsPage';

export const tableDataInit: ITableData = {
  data: [],
  pagination: initialPagination,
  filterOptions: {
    uniqueGeographicAreas: [],
    uniqueLicenses: [],
    uniqueOrganizationalEntities: [],
    uniqueUsers: [],
    uniqueWaterbodies: [],
    uniqueWaterbodySubtypes: [],
    uniqueMembershipTypes: [],
    uniqueLicenseRangeTypes: [
      { value: 'yearly', labelEn: 'Yearly', labelDe: 'Jährlich', labelFr: 'Annuel', labelIt: 'Annuale' },
      { value: 'daily', labelEn: 'Daily', labelDe: 'Täglich', labelFr: 'Quotidien', labelIt: 'Giornaliero' },
    ],
    uniqueLicenseTitles: ['Saisonpatent', 'Wochenpatent'],
  },
  loading: false,
  error: false,
};
